/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import type { Provider } from "@ethersproject/providers";
import type {
  IDelegate,
  IDelegateInterface,
} from "../../../contracts/interfaces/IDelegate";

const _abi = [
  {
    inputs: [],
    name: "AddressInvalid",
    type: "error",
  },
  {
    inputs: [],
    name: "ManagerInvalid",
    type: "error",
  },
  {
    inputs: [],
    name: "RuleExpiredOrDoesNotExist",
    type: "error",
  },
  {
    inputs: [],
    name: "SenderAmountInvalid",
    type: "error",
  },
  {
    inputs: [],
    name: "SenderInvalid",
    type: "error",
  },
  {
    inputs: [],
    name: "SignerAmountInvalid",
    type: "error",
  },
  {
    inputs: [],
    name: "TransferFromFailed",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "signatory",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "signer",
        type: "address",
      },
    ],
    name: "Authorize",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "senderWallet",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "signerWallet",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
    ],
    name: "DelegatedSwapFor",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "tmp",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "signer",
        type: "address",
      },
    ],
    name: "Revoke",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "senderWallet",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "senderToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "senderAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "signerToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "signerAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "expiry",
        type: "uint256",
      },
    ],
    name: "SetRule",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "senderWallet",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "senderToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "signerToken",
        type: "address",
      },
    ],
    name: "UnsetRule",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "manager",
        type: "address",
      },
    ],
    name: "authorize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "revoke",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "senderWallet",
        type: "address",
      },
      {
        internalType: "address",
        name: "senderToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "senderAmount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "signerToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "signerAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "expiry",
        type: "uint256",
      },
    ],
    name: "setRule",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_swapERC20Contract",
        type: "address",
      },
    ],
    name: "setSwapERC20Contract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "senderWallet",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "expiry",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "signerWallet",
        type: "address",
      },
      {
        internalType: "address",
        name: "signerToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "signerAmount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "senderToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "senderAmount",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "swap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "senderWallet",
        type: "address",
      },
      {
        internalType: "address",
        name: "senderToken",
        type: "address",
      },
      {
        internalType: "address",
        name: "signerToken",
        type: "address",
      },
    ],
    name: "unsetRule",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class IDelegate__factory {
  static readonly abi = _abi;
  static createInterface(): IDelegateInterface {
    return new utils.Interface(_abi) as IDelegateInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IDelegate {
    return new Contract(address, _abi, signerOrProvider) as IDelegate;
  }
}
